$(function(){

	var csrftoken = Cookies.get('csrftoken');

    var NewsletterPopup = {
    	config: {
    		endpoint: '',
    		endpointPopup: '',
    		submitBtn: '',
    		emailField: '',
    		modal: ''
    	},
        send: function(data) {
            var that = this;
            $.ajax({
                type: "POST",
                url: that.config.endpoint,
                headers: {
                    'X-CSRFToken': csrftoken
                },
                data: data,
                success: function(){
                    toastr.success('Thanks for signing up for the Slow Tours Newsletter');
                    that.closeModal();
                    ga('send', 'event', 'Newsletter Popup', 'Subscribed');
					ga("send","event","Form", "submit","Newsletter Popup Form");
                },
                error: function(xhr) {
                    toastr.warning(xhr.responseJSON['email']);
                }
            })
        },
        setCookie: function() {
        	var that = this;
            $.ajax({
                type: "POST",
                url: that.config.endpointPopup,
                headers: {
                    'X-CSRFToken': csrftoken
                }
            })
        },
        openModal: function() {
        	this.config.modal.modal('show')
        },
        closeModal: function() {
        	this.config.modal.modal('hide')
        },
        init: function(config) {
        	this.config = config;
            var that = this;
            if (this.config.modal.data('newsletter') == 'True') {
                /*$(window).bind('scroll.popup', function(){
                    var h = $(window).scrollTop();
                    if (h >= that.config.offset) {
                        $(window).unbind('scroll.popup');
                        $('.js-open-newsletter').click(function(){
                            ga('send', 'event', 'Newsletter Popup', 'Auto Open');
                        });
                        that.openModal();
                        that.setCookie();
                    }
                })*/ 
				if (window.location.href.indexOf("book-a-tour-in-") == -1) { 
					setTimeout(function(){
						$(document).on("mouseout", function(evt){
							if(evt.toElement === null && evt.relatedTarget === null) {
								$(evt.currentTarget).off("mouseout");
								// An intent to exit has happened
								$('.js-open-newsletter').click(function(){
									ga('send', 'event', 'Newsletter Popup', 'Auto Open');
								});
								that.openModal();
								that.setCookie();
							}
						});
					}, 5000);
				}
            }
            this.config.submitBtn.bind('click', function() {
                var email = that.config.emailField.val();
                var firstName = that.config.firstNameField.val();
                var lastName = that.config.lastNameField.val();
                if (!email || !firstName || !lastName) {
                    toastr.warning('All field are required');
                } else {
                    that.send({
                        email: email,
                        first_name: firstName,
                        last_name: lastName
                    })
                }
            });
        }
    };

    NewsletterPopup.init({
		endpoint: '/api/v1/newsletters',
		endpointPopup: '/api/v1/newsletter-popup',
		submitBtn: $('#newsletterpopbtn'),
		emailField: $('#newsletterpopemail'),
		firstNameField: $('#newsletterpopfirst'),
		lastNameField: $('#newsletterpoplast'),
		modal: $('#newslettermodal'),
		offset: 1000
    })


    // Tracking events
    $('.js-open-newsletter').click(function(){
        ga('send', 'event', 'Newsletter Popup', 'Open');
    });


    $('.js-close-newsletter').click(function(){
        ga('send', 'event', 'Newsletter Popup', 'closed');
    })


})